/**
 * Where a buyer came from: UTM tags and the referring site of the visit that
 * brought them, kept in this browser for 30 days and sent only with an order.
 * First party only; nothing goes to a third party.
 */
const KEY = "kj_attr_v1";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureAttribution() {
  try {
    const url = new URL(window.location.href);
    const utm = Object.fromEntries(UTM.map((k) => [k, url.searchParams.get(k)]).filter(([, v]) => v));
    let referrer = "";
    try {
      const ref = document.referrer ? new URL(document.referrer) : null;
      if (ref && ref.host !== window.location.host) referrer = `${ref.protocol}//${ref.host}${ref.pathname}`.slice(0, 200);
    } catch { /* bad referrer */ }
    const stored = JSON.parse(localStorage.getItem(KEY) || "null");
    const fresh = stored && Date.now() - (stored.saved || 0) < TTL_MS;
    // A new campaign link or a visit from another site replaces the old record;
    // a direct visit keeps what we already know.
    const newSource = Object.keys(utm).length > 0 || !!referrer;
    if (newSource || !fresh) {
      localStorage.setItem(KEY, JSON.stringify({
        ...utm, referrer, landing_path: url.pathname.slice(0, 200), first_seen: new Date().toISOString(), saved: Date.now(),
      }));
    }
  } catch { /* storage blocked: attribution is optional */ }
}

export function readAttribution() {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!a || Date.now() - (a.saved || 0) > TTL_MS) return null;
    const { saved, ...rest } = a;
    return rest;
  } catch {
    return null;
  }
}
